import { render, staticRenderFns } from "./TransferBytesToExternalAddressModal.vue?vue&type=template&id=52f4fe5e&scoped=true&"
import script from "./TransferBytesToExternalAddressModal.vue?vue&type=script&lang=js&"
export * from "./TransferBytesToExternalAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4fe5e",
  null
  
)

export default component.exports